/**
 * returns a formatted string with copied info
 *
 * @param {object} locationData - object is formed in CopyAllButton.js and it has the following keys:
 * callerID, source, locationTime, estimatedAddress, estimatedFloor, latitude, longitude, what3words, altitude, altitudeUncertaintyRadius, uncertaintyRadius, uncertaintyConfidence
 * @returns string
 */

export const handleClipboardData = locationData => {
  let str = '';
  Object.keys(locationData).forEach(i => {
    if (locationData[i]) {
      const lineExpression = `${formatLineTitle(i)}: ${locationData[i]}`;
      str += str === '' ? lineExpression : `\n${lineExpression}`;
    }
  });
  return str;
};

const formatLineTitle = key => {
  const titleByKey = {
    callerID: 'Caller ID',
    source: 'Source',
    locationTime: 'Location Time',
    estimatedAddress: 'Estimated Address - VERIFY',
    estimatedAddressProvider: 'Estimated Address Provider',
    estimatedFloor: 'Estimated Floor',
    latitude: 'Latitude',
    longitude: 'Longitude',
    what3words: 'What3Words',
    altitude: 'Altitude',
    altitudeUncertaintyRadius: 'Altitude Uncertainty Radius',
    uncertaintyRadius: 'Uncertainty Radius',
    uncertaintyConfidence: 'Uncertainty Confidence',
  };
  return titleByKey[key];
};
